const fieldSpacing = {
  CONTENT:  'content',
  SPACED:   'spaced',
  VIEWPORT: 'viewport',
};

const fieldSpacingList = [
  {
    text:             'Compact',
    value:            fieldSpacing.CONTENT,
    tooltip:          'Minimal spacing, sized based on the content',
    tooltipIsCompact: false,
  },
  {
    text:             'Spaced',
    value:            fieldSpacing.SPACED,
    tooltip:          'Adds additional spacing for a more comfortable layout',
    tooltipIsCompact: false,
  },
  {
    text:             'Max',
    value:            fieldSpacing.VIEWPORT,
    tooltip:          'Maximum spacing, in slide mode will expand to use available space',
    tooltipIsCompact: false,
  },
];

const fieldSpacingAll = _.values(fieldSpacing);

export { fieldSpacing, fieldSpacingList, fieldSpacingAll };

export default fieldSpacing;
